import Images from '../../common/Images'

export const data = [
  {
    month: 'January 2023',
    events: [
      {
        date: 'January 4th, 2023',
        content: 'Send acceptance emails to new team members.',
        icon: Images.IconTeam
      },
      {
        date: 'January 16th, 2023',
        content: 'Integrating new team members into the 2023 Team.',
        icon: Images.IconTeam
      },
      {
        date: 'January 31th, 2023',
        content: 'Beginning of the Project.'
      }
    ]
  },
  {
    month: 'February 2023',
    events: [
      {
        date: 'February 5th, 2023',
        content: 'Team registration.',
        icon: Images.IconTeam
      },
      {
        date: 'February 9th, 2023',
        content: 'Selection and Elaboration of the Project Ideas.'
      },
      {
        date: 'February 14th, 2023',
        content:
          'Final Selection of the Project Idea : Development of a universal blood processing system and Distribution of scientific articles to read between team members.'
      },
      {
        date: 'February 29th, 2023',
        content:
          'Human practices, meeting Josée Laganière, Ph. D. She is a Canadian researcher at Héma Québec working on Therapeutic applications of induced pluripotent stem cells (iPSC). We aimed to have some of her advice on the feasibility of the project and the relevance of working to remove which antigen.',
        icon: Images.IconTeam
      }
    ]
  },
  {
    month: 'March 2023',
    events: [
      {
        date: 'March 2th, 2023',
        content: 'Project name selection : Blood Cell Barber Shop.',
        icon: Images.IconModelling
      },
      {
        date: 'March 6th, 2023',
        content:
          'Beginning of background research on previous iGEM work on the subject.',
        icon: Images.IconModelling
      },
      {
        date: 'March 9th, 2023',
        content:
          'Design of the project’s name: Blood Cell Barber Shop / Confirmation of the team members.',
        icon: Images.IconTeam
      },
      {
        date: 'March 16th, 2023',
        content:
          'Podcast about iGEM and ULaval iGEM Teams at the Université Laval.',
        icon: Images.IconTeam
      },
      {
        date: 'March 19th, 2023',
        content: 'Forces Avenir contest writing session.'
      }
    ]
  },
  {
    month: 'April 2023',
    events: [
      {
        date: 'April 3rd, 2023',
        content:
          'Collaboration with iGEM Team Patras for Health Day, published April 7th.',
        icon: Images.IconTeam
      },
      {
        date: 'April 13th, 2023',
        content:
          'Gala for the Bureau de la vie étudiante (BVE) and Nominated to represent our university for Forces Avenir.',
        icon: Images.IconTeam
      },
      {
        date: 'April 19th, 2023',
        content: 'Inscription of ULaval iGEM Team for iGEM 2023.'
      },
      {
        date: 'April 25th, 2023',
        content: 'Collaboration with iGEM Team Patras for DNA Day.',
        icon: Images.IconTeam
      }
    ]
  },
  {
    month: 'May 2023',
    events: [
      {
        date: 'May 1st, 2023',
        content: 'Planification of the wet lab.',
        icon: Images.IconModelling
      },
      {
        date: 'May 15th, 2023',
        content: 'Design of the plasmid for the wet lab.',
        icon: Images.IconModelling
      },
      {
        date: 'May 18th, 2023',
        content: 'Design of the project’s logo/ Opening of our GoFundMe.'
      },
      {
        date: 'May 22th, 2023',
        content:
          'Planification of the dry lab with PhD candidate Angel Fernando Cisneros, former member and mentor of iGEM and student in the Landry laboratory at Laval University, and design of the enzymatic chip.',
        icon: Images.IconModelling
      },
      {
        date: 'May 29th, 2023',
        content:
          'Found the sequence for B antigen and the enzyme we need (α-galactosidase) / Plan assembly for the genes that we are going to order.',
        icon: Images.IconImplement
      }
    ]
  },
  {
    month: 'June 2023',
    events: [
      {
        date: 'June 5th, 2023',
        content:
          'Comparing the alpha-galactosidase sequence with that of past iGEM teams.'
      },
      {
        date: 'June 7th, 2023',
        content: 'Interview for Forces AVENIR.',
        icon: Images.IconTeam
      },
      {
        date: 'June 8th, 2023',
        content:
          'Choice of our project title (An enzymatic treatment for universal blood donations) and our track (Therapeutic) / Ordering gBlocks from IDT.',
        icon: Images.IconModelling
      },
      {
        date: 'June 11th, 2023',
        content: 'Impact Grant writing session.'
      },
      {
        date: 'June 13th, 2023',
        content: 'iGEM Opening Day and design of primers for the sequencing.'
      },
      {
        date: 'June 15th, 2023',
        content: 'Safety Forms working session.'
      },
      {
        date: 'June 19th, 2023',
        content:
          'Drafting of characterization, cloning and protein extraction protocols (Wet Lab)',
        icon: Images.IconImplement
      },
      {
        date: 'June 22th, 2023',
        content: 'Forces Avenir+ contest writing session.',
        icon: Images.IconModelling
      },
      {
        date: 'June 26th, 2023',
        content:
          'Beginning of dry lab: Comparison of isoform lengths 1 and 7 for Rhesus (RhD) / Wet lab : purchase of all necessary components.'
      },
      {
        date: 'June 28th, 2023',
        content: 'Beginning of wet lab: plasmid stock preparation.'
      },
      {
        date: 'June 29th, 2023',
        content:
          'Meeting with Prof. Stéphane Gagné, a protein structure prediction expert, for our dry lab.',
        icon: Images.IconTeam
      }
    ]
  },
  {
    month: 'July 2023',
    events: [
      { date: 'July 3rd, 2023', content: 'Dry lab: Modeling Rh’s structure.' },
      {
        date: 'July 7th, 2023',
        content: 'Wet lab : Replacement of E. coli pET-3a long storage stock.'
      },
      {
        date: 'July 11th, 2023',
        content: 'Wet lab : Assembly of our DNA cassettes.'
      },
      {
        date: 'July 11th, 2023',
        content:
          'Wet lab : Restriction-ligation cloning of DNA cassettes into pET-3a vector.'
      },
      {
        date: 'July 13th, 2023',
        content:
          'Wet lab:  Assay 1 - Transformation of GH110b, GH110a and P0DTR5 into E. coli DH5α competent cells. / Dry lab: Contact Valerie Ward, assistant professor in the Chemical Engineering Department at the University of Waterloo,  for enzyme modeling and binding.',
        icon: Images.IconImplement
      },
      {
        date: 'July 14th, 2023',
        content:
          'Beginning of modelisation and prediction of protein structures.',
        icon: Images.IconModelling
      },
      { date: 'July 15th, 2023', content: 'Plasmid digestion assay.' },
      {
        date: 'July 16th, 2023',
        content: 'Meeting to prepare day camp activities.',
        icon: Images.IconTeam
      },
      {
        date: 'July 20th, 2023',
        content:
          'Dry lab: Secondary structure prediction and beginning of heterodimer and dimer modelling.'
      },
      {
        date: 'July 20th, 2023',
        content:
          'Meeting with Hossein Hassanzadeh, Ph. D. Université Laval student studying fluid dynamics.',
        icon: Images.IconTeam
      },
      {
        date: 'July 20th, 2023',
        content:
          'Summer camp activity : we organized an interactive activity for the children at a summer camp.',
        icon: Images.IconTeam
      },
      {
        date: 'July 26th, 2023',
        content:
          'Wet lab : Assay 2 - Transformation of GH110b, Gh110a and P0DTR5 into E. coli DH5α competent cells.'
      }
    ]
  },
  {
    month: 'August 2023',
    events: [
      {
        date: 'August 3rd, 2023',
        content:
          'Beginning of work on the wiki / Wet lab : preparation of long storage stocks of P0DTR5, GH110b and GH110a.'
      },
      {
        date: 'August 4th, 2023',
        content:
          'Wet lab : Assay 1 - Transformation of GH110b, GH110a and P0DTR5 into E. coli BL21(DE3) competent cells.'
      },
      {
        date: 'August 5th, 2023',
        content: 'Promotional video filming.',
        icon: Images.IconTeam
      },
      {
        date: 'August 7th, 2023',
        content:
          'Meeting with Patrick Lagüe, Ph. D., about molecular dynamics.',
        icon: Images.IconTeam
      },
      {
        date: 'August 8th, 2023',
        content:
          'Dry lab: Molecular dynamics and membrane modeling / Wet lab : Assay 1 - Transformation of GH110b, GH110a and P0DTR5 into E. coli  BL21(DE3) competent cells',
        icon: Images.IconModelling
      },
      {
        date: 'August 9th, 2023',
        content:
          'Dry lab : Wet lab : Assay 3 - Transformation of GH110b, GH110a and P0DTR5 into E. coli BL21(DE3) competent cells'
      },
      {
        date: 'August 24th, 2023',
        content:
          'Wet lab : Transformation of GH110b, GH110a and P0DTR5 into Rosetta (DE3)pLysS competent cells.'
      },
      {
        date: 'August 28th, 2023',
        content: 'Final Safety form.',
        icon: Images.IconSafety
      },
      {
        date: 'August 31st, 2023',
        content:
          'Wet lab: Purification and analysis with SDS-PAGE of ɑ-galactosidase, Gh100b and p0dtr5 + Qualitative Bradford assay'
      }
    ]
  },
  {
    month: 'September 2023',
    events: [
      {
        date: 'September 1st, 2023',
        content: 'Wet lab: Qualitative enzymatic test'
      },
      {
        date: 'September 6th, 2023',
        content: 'Start of Computational Fluids Dynamics (CFD).',
        icon: Images.IconImplement
      },
      {
        date: 'September 8th, 2023',
        content: 'Dry lab: First CFD model completed'
      },
      {
        date: 'September 11th, 2023',
        content: 'Evaluation of the first CFD models.',
        icon: Images.IconImplement
      },
      {
        date: 'September 15th, 2023',
        content: 'Dry lab : Second CFD model completed.'
      },
      {
        date: 'September 18th, 2023',
        content: 'Dry lab : Analysis of the second CFD models.'
      },
      {
        date: 'September 20th, 2023',
        content: 'Dry lab: End of Computational Fluids Dynamics Analysis.',
        icon: Images.IconImplement
      },
      {
        date: 'September 20th, 2023',
        content: 'End of wet lab.',
        icon: Images.IconImplement
      },
      {
        date: 'September 21st, 2023',
        content: 'Postcards collaboration with iGEM Düsseldorf.',
        icon: Images.IconTeam
      },
      {
        date: 'September 30th, 2023',
        content: 'In person meeting to finalize the pages of our wiki.'
      }
    ]
  },
  {
    month: 'October 2023',
    events: [
      {
        date: 'October 1st, 2023',
        content: 'Preliminary judging session, project title and abstract due.'
      },
      { date: 'October 12th, 2023', content: 'Wiki freeze.' }
    ]
  },
  {
    month: 'November 2023',
    events: [
      {
        date: 'November 2-5th, 2023',
        content: 'Attending the Grand Jamboree!'
      }
    ]
  }
]
